app.service('subscriptionServices', function (loading, modal, subscriptionServiceInvoiceForm, subscriptionResignForm) {

	let subscriptionServiceContractId;
	let subscriptionServiceName = '';

	function init(props) {
		const {onPageChange} = props;

		setEvents(onPageChange);

		subscriptionServiceInvoiceForm.init({loadSubscriptionServiceDetails});
	}

	function setEvents(onPageChange) {
		$('body')
			.on('click', '.js-service-details-toggle', function handleServiceDetailsToggleClick() {
				$(this).closest('.additional-options').toggleClass('show-more').toggleClass('show-less');
			})
			.on('click', '.js-subscription-services-page', function handleSubscriptionServicesPageClick() {
				const pageNumber = $(this).data('page');
				onPageChange(pageNumber);
				$.scrollTo($('#subscription-payment-list'), 0);
			})
			.on('click', '.js-subscription-services-resign', handleSubscriptionContractResignClick)
			.on('click', '.js-subscription-services-details', handleSubscriptionServiceDetailsClick)
			.on('click', '#service-resign-modal .remodal-close', function() {
				sendUA("Przycisk X");
			});

		$(document).on('click', function (e) {
			if ($(e.target).closest(".additional-options").length === 0) {
				$(".additional-options").removeClass('show-less').addClass('show-more');
			}
		});

		$(document)
			.on('closed', '#service-resign-modal', function (event, data) {
				if (data.reason && data.reason === 'outsideClick') {
					sendUA("Kliknięcie poza warstwę");
				}
			});
	}

	function handleSubscriptionContractResignClick() {
		subscriptionServiceContractId = $(this).data('id');
		subscriptionServiceName = $(this).data('name');

		loading.start();
		$.ajax({
			url: "/customer-subscription-service-contract-close-reason.ltr",
			type: "GET",
			success(questionnaireHtml) {
				openModal(questionnaireHtml);
			},
			error() {
				modal.alert('Wystąpił błąd komunikacji, prosimy spróbować później.');
			},
			complete() {
				loading.stop();
			}
		});
	}

	function openModal(questionnaireHtml) {

		const content =
			`<p>Twoja rezygnacja z usługi ${subscriptionServiceName} wraz z usługą płatności cyklicznej jest nieodwracalna.</p>
			<p>Nie będziesz mógł ponownie aktywować tej usługi.</p>
			${questionnaireHtml}`;

		modal.generate({
			id: 'service-resign-modal',
			header: 'Rezygnacja z mikropłatności miesięcznej (subskrypcji)',
			content,
			buttons: [
				{
					text: "Wróć",
					cssClass: 'cancel-resignation',
					click: function () {
						modal.close();
						sendUA("Przycisk Wróć");
					}
				},
				{
					text: "Potwierdzam rezygnację",
					cssClass: 'confirm-resignation is-disabled',
					click: function () {
						handleConfirmSubscriptionContractResignClick();
					}
				}
			]
		});
	}

	function sendUA(reason) {
		UA.push({
			event: "visitorInteraction",
			eventCategory: "InsuranceQuestionnaire",
			eventAction: "Zamknięcie popupa",
			eventLabel: reason
		});
	}

	function handleConfirmSubscriptionContractResignClick() {
		loading.start();

		const {closeReasonName, closeReasonDescription} = subscriptionResignForm.getResignFormData();

		$.ajax({
			url: '/customer-subscription-service-contract-close.ltr',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				subscriptionServiceContractId: subscriptionServiceContractId,
				closeReasonName,
				closeReasonDescription
			}),
			success: function (result) {
				if (result.status === 'SUCCESS') {
					window.location.hash = "uslugi";
					location.reload();
				} else {
					loading.stop();
					modal.alert(result.messages[0]);
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd komunikacji, prosimy spróbować później.');
			}
		});
	}

	function handleSubscriptionServiceDetailsClick() {

		const recurringPaymentId = $(this).data('recurring-payment-id');
		const initialOrderId = $(this).data('initial-order-id');
		const pluList = $(this).data('plu-list');

		makeSubscriptionServiceDetailsRequest(recurringPaymentId, initialOrderId, pluList);
	}

	function makeSubscriptionServiceDetailsRequest(recurringPaymentId, initialOrderId, pluList) {

		let $box = $(`.subscription-item[data-id="${recurringPaymentId}"]`);

		loadSubscriptionServiceDetails(recurringPaymentId, initialOrderId, pluList)
			.then(html => {
				$('.subscription-item-details', $box).html(html);
			})
			.fail(() => {
				$('.subscription-item-details', $box).html('<div class="error">Wystąpił błąd komunikacji, prosimy spróbować później.</div>');
			});
	}

	function loadSubscriptionServiceDetails(recurringPaymentId, initialOrderId, pluList) {
		loading.start();

		return $.ajax({
			url: `/customer-subscription-service-contract-details.ltr`,
			type: "GET",
			data: {
				recurringPaymentId,
				initialOrderId,
				pluList
			}
		}).always(() => {
			loading.stop();
		});
	}

	function showSubscriptionDetails(recurringPaymentId) {
		const $subscriptionItem = $(`.subscription-item[data-id="${recurringPaymentId}"]`);
		if (!$subscriptionItem.length) {
			return;
		}
		let $detailsButton = $subscriptionItem.find('.js-subscription-services-details');
		const initialOrderId = $detailsButton.data('initial-order-id');
		const pluList = $detailsButton.data('plu-list');

		makeSubscriptionServiceDetailsRequest(recurringPaymentId, initialOrderId, pluList);
	}

	/**
	 * Prezentacja zaległych płatności na stronie /konto.bhtml
	 */
	function checkForAccountOverdueSubscriptions() {
		const $accountOverdueSubscriptions = $('#overdue-services');
		const $accountMenu = $('#katalog-prod');
		if ($accountOverdueSubscriptions.length && $.trim($accountOverdueSubscriptions.html()).length === 0) {
			$.ajax({
				url:'/customerAccountOverdueSubscriptionServices.ltr',
				success: function(html) {
					if (html){
						$accountOverdueSubscriptions.html(html);
						$accountMenu.addClass('overdue-payment-label');
					}
				}
			});
		}
	}

	return {
		init,
		showSubscriptionDetails,
		checkForAccountOverdueSubscriptions,
		handleSubscriptionContractResignClick
	};
});